// extracted by mini-css-extract-plugin
module.exports = {"footer":"O6dfT","footerLeftSide":"_1GRU2","likesCount":"_3E9us","commentsCountContainer":"YPPwR","commentsCount":"RAKVN","tooltip":"QR_lk"};